import {mash} from "@/store/Services";


async function asd(accountCode, competitorOnlineProfileIds) {

    const profilesList = [];

    const axiosResponse = await mash.get(
        "/rest/accounts/" + accountCode + "/online-profiles/"
        + competitorOnlineProfileIds.join(','));

    for (const index in axiosResponse.data) {
        const compProfile = axiosResponse.data[index];

        // Map Mash profile type to channel for compatibility
        let channel = null;
        if (compProfile.type) {
            const type = compProfile.type.toUpperCase();
            if (type.includes('FACEBOOK')) {
                channel = 'FACEBOOK';
            } else if (type.includes('INSTAGRAM')) {
                channel = 'INSTAGRAM';
            } else if (type.includes('TWITTER')) {
                channel = 'TWITTER';
            } else if (type.includes('LINKEDIN')) {
                channel = 'LINKEDIN';
            } else if (type.includes('YOUTUBE')) {
                channel = 'YOUTUBE';
            } else if (type.includes('TIKTOK')) {
                channel = 'TIKTOK';
            }
        }

        profilesList.push({
            handleId: compProfile.handleId,
            handle: compProfile.handle,
            brandId: competitorOnlineProfileIds[index],
            type: compProfile.type,  // Keep the original type
            channel: channel
        });
    }

    return profilesList;
}

export default asd;